module.exports = __webpack_public_path__ + "img/1.ecd25ada.jpg";